// Import global utils
import { isDefined } from '@automator/shared/utils/is-defined';

/**
 * Given a group code and connection code, checks if a connection exists
 *
 * @param {Object} options                 The options
 * @param {String} options.integrationCode The unique code of the integration
 * @param {String} options.conditionCode   The unique code of the condition
 * @return {Object}                        The condition data
 */
const getConditionPostData = ( { integrationCode, conditionCode } ) => {
	let condition;

	// Check if the integration exists
	if ( isDefined( UncannyAutomator.integrations[ integrationCode ] ) ) {
		// Get available conditions
		const availableConditions = UncannyAutomator.integrations[ integrationCode ].conditions.available;

		// Check if the condition exists
		if ( isDefined( availableConditions[ conditionCode ] ) ) {
			// Retrieve condition
			condition = availableConditions[ conditionCode ];
		}
	}

	return condition;
};

export default getConditionPostData;
